import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";

import Loadable from "react-loadable";
import "./App.scss";

import GlobalContextProvider from "./context/GlobalContext";
import loginAPI from "./services/loginAPI";
import PrivateRouteLayout from "./containers/PrivateRouteLayout";
const loading = () => (
  <div className="animated fadeIn pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const DefaultLayout = Loadable({
  loader: () => import("./containers/DefaultLayout"),
  loading,
});

// Pages
const Login = Loadable({
  loader: () => import("./views/Pages/Login"),
  loading,
});

const theme = createMuiTheme({
  palette: {
    type: "dark",

    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#20a8d8",
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
  },
});

const App = (props) => {
  const user = loginAPI.currentUser();
  console.log(user);
  if (user !== null) {
  }
  return (
    <GlobalContextProvider>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Switch>
            <Route exact path="/login" name="Login Page" component={Login} />

            <PrivateRouteLayout
              path="/"
              name="Home"
              component={DefaultLayout}
            />
          </Switch>
        </BrowserRouter>
      </ThemeProvider>
    </GlobalContextProvider>
  );
};

export default App;
